module.exports = __webpack_public_path__ + "img/hettetroll.48a6a6d5.jpg";